import { gql } from '@apollo/client';

export const ADMIN_OPENTABLE_SYNCS_QUERY = gql`
  query AdminOpentableSyncs(
    $after: String
    $first: Int
    $orderBy: String
    $order: String
    $status: String
  ) {
    adminOpentableSyncs(
      after: $after
      first: $first
      orderBy: $orderBy
      order: $order
      status: $status
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        type
        status
        externalId
        lastSyncedAt
        errorMessage
        createdAt
        updatedAt
        eventId
        eventName
        eventStatus
        startDate
        endDate
        startOffset
        endOffset
        groupSize
        guestName
        guestEmail
        guestPhone
        venueId
        venueName
        opentableRestaurantId
        spaceNames
        opentableCustomInstructions
      }
    }
  }
`;

export const ADMIN_MARK_OPENTABLE_SYNC_COMPLETE_MUTATION = gql`
  mutation AdminMarkOpentableSyncComplete($id: ID!, $reservationId: String) {
    adminMarkOpentableSyncComplete(
      input: { id: $id, reservationId: $reservationId }
    ) {
      opentableSync {
        id
        status
        externalId
        lastSyncedAt
      }
      errors {
        message
      }
    }
  }
`;